





























































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import { ImportedExpense } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useExpenseStore } from "@/employee/store/expense";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class PersonalExpenseTracker extends Vue {
  expenseStore = useExpenseStore();
  moment = moment;
  formatCurrency = formatCurrency;
  filterReimbursed = false;

  mounted (): void {
    this.expenseStore.getImportedExpenses();
  }

  get filterExpenses (): ImportedExpense[] {
    if (this.filterReimbursed) {
      return this.expenseStore.importedExpenses.filter(e => e.source === "Reimbursed");
    } else {
      return this.expenseStore.importedExpenses.filter(e => e.source !== "Reimbursed");
    }
  }

  createDownloadLink (reimbursedExpenseId: number, fileName: string): void {
    this.expenseStore.importedExpenseAttachmentGet({ reimbursedExpenseId, fileName });
  }
}
